export default {
  sendTemplateButton: 'Send template',
  sendTemplateDescription: 'When the recipient responds, you can chat normally',
  resumeConversationsMessage: 'It has been a while...',
  resumeConversationButton: 'Resume conversation',
  sendMsgButton: 'Send Message',
  conversationWithAdvisorTitle: 'Don\'t worry!',
  conversationWithAdvisorDescription: 'This conversation has been taken by',
  takeConversationDescription: 'Someone is waiting for you',
  takeConversationButton: 'Take conversation',
  welcomeTitle: 'Welcome to Keybe',
  welcomeDescription: 'I look good, don\'t you?',
  chatsOf: 'chats of',
  noAppSelected: 'There are no conversations, please select an application',
  closeReason: 'Reason for end conversation',
  noCloseReason: 'You have not configured any reasons for end conversation.',
  errorUpdateAdviserStatus: 'Error updating adviser status',
  emptyQuickResponses: 'Quick responses not found',
  pressESCToClose: 'Press ESC to close',
  productCatalog: 'Products Catalog',
  noCatalog: 'Catalog not configured',
  meta: 'Meta.inc',
  resumeConversationsMessage1: 'This conversation was closed due to inactivity according to the policies of',
  resumeConversationsMessage2: 'you can chat normally when the other person replies to your message.',
  resumeConversationButton2: 'Send another message? 🤔 ',
  metaRulesMessage1: 'It\'s been more than 7 days since this conversation was active and the rules of',
  metaRulesMessage2: 'don\'t allow us to resume this conversation',
  unsupportedMessage: 'Unsupported message.\nThis message is not supported by Meta.inc, use the Instagram app to see this message.',
  toggleSound: 'Toggle sound',
  turnOnSound: 'Turn on sound',
  turnOffSound: 'Turn off sound',
  kbYeah: 'Keybe Yeah',
  kbCash: 'Keybe Cash',
  kbClassic: 'Keybe Classic',
  kbFeels: 'Keybe Feels',
  kbHappy: 'Keybe Happy',
  kbSky: 'Keybe Sky',
  kbSynth: 'Keybe Synth',
  kbWhite: 'Keybe White',
  tone: 'Tone',
  chatConfiguration: 'Chat settings',
  addKeybeIntel: 'Activate the Intel mode and add Artificial Intelligence to your core',
  addKeybeIntelDescription: 'Artificial Intelligence powering the natural intelligence of your advisors, grow without limits!',
  sentimentalAnalysis: 'Sentiment analysis',
  sentimentalAnalysisDescription: 'One step further, through AI you will know how the customer feels to calculate your next move',
  dataEnrichment: 'Data enrichment',
  dataEnrichmentDescription: 'It\'s not a crystal ball, with our data enrichment, you will know all the available information about that person',
  predictedAnswers: 'Message suggestions',
  predictedAnswersDescription: 'Answer with one click, our Artificial intelligence will allow you to answer up to xx% faster',
  soon: 'Soon',
  byRequest: 'Per message',
  by3Messages: 'Per 3 suggestions',
  errorGettingSentimentsConfig: 'Error getting the configuration',
  errorSettingSentimentsConfig: 'Error saving the configuration',
  configsTutorial1: 'Set your preferences and activate Keybe\'s Artificial Intelligence in one place.',
  configsTutorial2: 'Now searching is simpler and faster.',
  keybeIntelTutorial1: 'Go one step further with Artificial Intelligence that helps you know the mood of the people you chat with.',
  keybeIntelTutorial2: 'Your chat settings in one place, change the tone of the message, or activate the dark mode, your app your rules!',
  keybeIntelTutorial3: 'Smarter filters to improve the way you chat.',
  templateComposerTitle: 'Before sending a message through the Whatsapp Business API, we ask you to be kind and avoid sending spam',
  actionSuggestions: 'Automatic detection',
  actionSuggestionsDescription: 'Automatically detects data and opportunities',
  refreshSuggestions: 'Refresh suggestions',
  isInvitingYouToACall: 'is inviting you to a call...',
  appInternal1: 'Now in KB: you can chat with your team and create working groups 🧑🏻‍💻👩🏽‍💻.',
  appInternal1sub1: 'Follow this tutorial and we will teach you how to do it 👀',
  appInternal1sub2: 'WhatsApp Command',
  appInternal1sub3: 'Windows : CTRL + S',
  appInternal1sub4: 'Mac : CMD + S',
  appInternal2: 'Here you can quickly search for the people you want to chat with and start a new conversation in a matter of seconds via KB: or WhatsApp 🤓',
  appInternal2sub1: 'Command',
  appInternal2sub2: 'Windows : CTRL + I',
  appInternal2sub3: 'Mac : CMD + I',
  appInternal3: 'Now, if what you want is to create a group with 2 or more people, you just have to go to the "New Internal Group" option, search and select the contacts you want to include in this space and that\'s it, it\'s that easy 😌',
  appInternal3sub1: 'Command',
  appInternal3sub2: 'Windows : CTRL + G',
  appInternal3sub3: 'Mac : CMD + G',
  appInternal4: 'And finally, easily access your chats and work groups created in the "Team" tab',
  mentionAllPeople: 'Mention all advisors',
  mentionOnlinePeople: 'Mention online advisors',
  maintenanceMessage: 'We are updating our platform. Please try again at 6:00 a.m. (GMT -5) on May 21st 🔜'
}
